/// <reference types="node" />

import { createHttpClient, createHttpInstance } from '@musinsa/packages-http';

/**
 * 무신사 주문(order-service) API 전용 HTTP 클라이언트.
 *
 * 배송지 단건 조회(`/order-service/my/addresses/getMemberAddress/{addressId}`) 등
 * 무신사 본진 order-service 를 호출한다.
 *
 * base URL 은 `NEXT_PUBLIC_MUSINSA_BASE_URL` 환경변수 사용.
 * 예) dev: https://www.dev.musinsa.com  /  prod: https://www.musinsa.com
 *
 * `.musinsa.com` 쿠키 기반 인증을 위해 `withCredentials: true` 를 사용하며,
 * 29CM(또는 무신사 로그인이 없는) 환경에서는 호출자 레벨에서
 * `service === SERVICE.MUSINSA` 가드로 호출을 차단한다. (musinsaSnapClient 동일 패턴)
 */
const instance = createHttpInstance({
  baseURL: process.env.NEXT_PUBLIC_MUSINSA_BASE_URL ?? '',
  withCredentials: true,
});

export const musinsaOrderClient = createHttpClient(instance);
